import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CookieConsentService } from '../../../core/services/cookie-consent.service';
import { TranslationService } from '../../../core/services/translation.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent implements OnInit {
  showBanner = false;
  showDetails = false;
  showPreferences = false;
  
  // Cookie preferences
  analyticsEnabled = true;
  marketingEnabled = true;
  preferencesEnabled = true;
  
  constructor(
    private cookieConsentService: CookieConsentService,
    private translationService: TranslationService
  ) {}
  
  ngOnInit(): void {
    // Only show the banner if consent hasn't been given yet
    const hasShownBanner = this.cookieConsentService.hasShownBanner();
    this.showBanner = !hasShownBanner;
  }
  
  acceptAll(): void {
    this.cookieConsentService.acceptAll();
    this.showBanner = false;
    this.showPreferences = false;
  }
  
  acceptNecessaryOnly(): void {
    this.cookieConsentService.acceptNecessaryOnly();
    this.showBanner = false;
    this.showPreferences = false;
  }
  
  savePreferences(): void {
    this.cookieConsentService.savePreferences(
      this.analyticsEnabled,
      this.marketingEnabled,
      this.preferencesEnabled
    );
    this.showBanner = false;
    this.showPreferences = false;
  }
  
  togglePreferences(): void {
    this.showPreferences = !this.showPreferences;
  }
  
  closeDetails(): void {
    this.showDetails = false;
    this.showPreferences = false;
  }
  
  // Method to translate text
  translate(key: string): string {
    return this.translationService.translate(key);
  }
}
